// Atalhos do Rete. Campos com efeitos colaterais (menu_tp, templates, uploads,
// selects dependentes de CRM/BD) continuam no formulário completo.
const primaryFields = {
  1: ["cfe_mensagem"],
  2: ["cfe_variavel", "chatbot_formatacao_entrada_id", "timeout"],
  3: ["cfe_variavel"],
  4: ["cfe_mensagem", "cfe_atributo"],
  5: ["cfe_time", "cfe_prioridade", "cfe_mensagem"],
  9: ["cfe_req_http", "cfe_url", "variavel_retorno"],
  11: ["cec_condicao", "cfe_mensagem"],
  12: ["cfe_variavel"],
  13: ["cfe_variavel"],
  15: ["cfe_atributo"],
  16: ["cfe_variavel", "bool_baixar_arquivo", "timeout"],
  17: ["chatbot_agenda_id", "cliente_padrao"],
  18: ["cfe_variavel", "chatbot_formatacao_entrada_id", "timeout"],
  19: ["cfe_variavel", "modelo_link_id", "sistema_licenciada_id"],
  20: ["agendamento_multiplo", "variavel_agendamento"],
  21: ["nome_variavel", "cabecalho"],
  22: ["cfe_atributo"],
  23: ["cfe_inteligencia_artificial", "cfe_tempo_inatividade"],
  24: ["tipo_reagendamento", "cfe_time"],
  25: ["atributos_customizaveis"],
  26: ["cfe_mensagem", "tipo_arquivo", "select_orientacao"],
  27: ["cfe_atributo", "tratamento"],
  28: ["cfe_variavel", "cfe_atributo"],
  29: ["cfe_atributo", "cfe_mensagem", "cfe_variavel"],
  30: ["cfe_atributo", "cfe_variavel"],
  31: ["limpar_variaveis"],
  32: ["tipo_questionario", "variavel", "variavel_resultado"],
  33: ["cfe_url"],
  34: ["lead_titulo", "lead_valor"],
  35: ["variavel_origem", "variavel_destino", "tipo_conversao_id"],
  36: [
    "cfe_req_http_upload_arquivo",
    "cfe_url_upload_arquivo",
    "cfe_content_upload_arquivo"
  ],
  37: ["variavel_nome", "texto_link", "mensagem"],
  38: ["cfe_mensagem", "cfe_variavel", "timeout"],
  39: ["caixa_entrada", "texto_link", "mensagem"],
  40: ["cfe_mensagem"]
};

export function reteInlineFields(stage, fieldOptions = {}) {
  const id = Number(stage.chatbot_estagio_id);
  const raw = stage.ces_metadata?.campos;
  if (!Array.isArray(raw)) return [];
  const fields = raw.flat();
  return (primaryFields[id] || [])
    .map((key) => {
      const field = fields.find((item) => item?.bindText === key);
      if (!field || field.showOn) return null;
      if (id === 25 && key === "atributos_customizaveis") {
        return {
          field,
          kind: "custom-attributes",
          options: fieldOptions.atributos_customizaveis || []
        };
      }
      const options =
        field.options || fieldOptions[`${id}:${key}`] || fieldOptions[key];
      if (["select", "multiSelect"].includes(field.type)) {
        if (!Array.isArray(options)) return null;
      } else if (
        !["text", "textArea", "textarea", "bool"].includes(field.type)
      ) {
        return null;
      }
      if (
        ["text", "textArea", "textarea"].includes(field.type) &&
        field.value != null &&
        !["string", "number"].includes(typeof field.value)
      )
        return null;
      return {
        field,
        options: options || [],
        readonly:
          key === "cfe_mensagem" &&
          fields.some(
            (item) =>
              item.bindText === "usar_meta_template" && item.value === true
          )
      };
    })
    .filter(Boolean);
}
